import React from 'react'

const Footer = () => {
  return (
    <div
        style={{
            position: `fixed`,
            bottom: `0px`,
            left: `0px`,
            padding: `10px`,
            display: `flex`,
            width: `100%`,
            flexFlow: `row wrap`,
            justifyContent: `space-between`,
            fontSize: `.6em`,
            opacity: `.6`
        }}
        >
        <div><span>{ typeof window !== `undefined` ?  window.location.pathname.replace('/', '') : 0 }</span></div>
        <div><span><a href="https://dangoslen.me">@dangoslen</a></span></div>
    </div>
    )
}

export default Footer